var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Circle with Dollar Sign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circleBg",
    cx: 22.9,
    cy: 23,
    r: 22.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circleBorder",
    d: "m22.9 46c-12.7 0-23-10.3-23-23s10.3-23 23-23 23 10.3 23 23-10.2 23-23 23zm0-44.5c-11.9 0-21.5 9.6-21.5 21.5s9.6 21.5 21.5 21.5 21.6-9.6 21.6-21.5-9.7-21.5-21.6-21.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "circleIcon",
    d: "m25.4 22.6h-1v-5.7h1c1.7 0 3 1.3 3 2.8h2c0-2.6-2.2-4.7-5-4.7h-1v-3h-2v3h-1c-2.8 0-5 2.1-5 4.7s2.2 4.7 5 4.7h1v5.7h-1c-0.8 0-1.6-0.3-2.1-0.8-0.6-0.5-0.9-1.3-0.9-2h-2c0 2.6 2.2 4.7 5 4.7h1v3h2v-3h1c2.8 0 5-2.1 5-4.7s-2.3-4.7-5-4.7zm-4 0c-1.7 0-3-1.3-3-2.8s1.3-2.8 3-2.8h1v5.6h-1zm4 7.5h-1v-5.7h1c1.7 0 3 1.3 3 2.8s-1.4 2.9-3 2.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollarSign.d5914b8b9946214e060e5e518e82c6dc.svg";
export { ForwardRef as ReactComponent };